import React from 'react'
import { VerticalNav } from 'components/ui/vertical-nav'
import type { VerticalNavItemType } from '../vertical-nav/VerticalNavItem'
import styles from './index.module.css'

type Props = {
  children: React.ReactNode
  nav: VerticalNavItemType[] | null | undefined
  title: string
}

/**
 * A layout component that provides a sidebar navigation structure for pages
 * @param children - Main content to display in the page layout
 * @param nav - Array of navigation items for the sidebar, or null/undefined to hide sidebar
 * @param title - Title text to display in the sidebar header
 * @returns Page layout with conditional sidebar navigation and main content area
 */
const PageLayout = ({ children, nav, title }: Props) => {
  return (
    <div className={styles.pageLayout}>
      {nav && (
        <div className={styles.pageLayoutSidebar}>
          <div className={styles.pageLayoutTitle}>{title}</div>
          <VerticalNav items={nav} />
        </div>
      )}
      <div className={styles.pageLayoutContent}>{children}</div>
    </div>
  )
}

export default React.memo<Props>(PageLayout)
